module.exports = __webpack_public_path__ + "static/media/JustFleckless–01Nature.7e3e84c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/JustFleckless–01Nature.jpg
// module id = 20
// module chunks = 0